import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FormSubmissionEntity } from './form-submission.entity';

export type FormSubmissionEventType =
	| 'note'
	| 'status_changed'
	| 'spam_changed'
	| 'assigned'
	| 'action_succeeded'
	| 'action_skipped'
	| 'action_failed'
	| 'action_rerun'
	| 'converted'
	| 'linked'
	| 'attached'
	| 'exported'
	// PD-16573 — the inbox's Create issue and Check again.
	| 'issue_created'
	| 'matches_checked';

/**
 * A submission's timeline and audit trail in one list: staff notes and everything the
 * system did (status and spam changes, assignment, action results, exports).
 */
@Index('idx_form_submission_event_submission', ['fkFormSubmissionId'], {})
@Entity('form_submission_event')
export class FormSubmissionEventEntity extends BaseEntity {
	@Column('int', { name: 'fk_form_submission__id', unsigned: true })
	public fkFormSubmissionId!: number;

	@Column('varchar', { name: 'eventType', length: 30 })
	public eventType!: FormSubmissionEventType;

	// Tenant-local user who did it; null when the system did.
	@Column('int', { name: 'fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;

	// A staff note's text.
	@Column('text', { name: 'body', nullable: true })
	public body!: string | null;

	@Column('json', { name: 'data', nullable: true })
	public data!: Record<string, unknown> | null;

	@ManyToOne(() => FormSubmissionEntity, { createForeignKeyConstraints: false })
	@JoinColumn([{ name: 'fk_form_submission__id', referencedColumnName: 'id' }])
	public submission!: FormSubmissionEntity;
}
